import React, { useContext, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import apiCall from "../../../../../../apicall";
import SectionRecordsFilter from "../../../../public-user/sections/common/section-records-filter";
import SectionTrustedWorkerEmployeeList from "./section-trusted-worker-employee-list";
import { JobDetailsContext } from "../job-detail1";
import Toast from "../../../../../common/toast";

const TrustedWorkersEmployeeList = () => {
  const { TOKEN, userInfo, role_type } = useSelector((state) => state.menu);
  const { jobDetailsInfo, positionDropdownList } =
    useContext(JobDetailsContext);
  const [isAdminRole] = useState(role_type?.includes("ROLE_OPENSTAFF_ADMIN") ||
    role_type?.includes("ROLE_OPENSTAFF_FINANCIAL_ADMIN"));
  const [tableFilter, setTableFilter] = useState({
    sortType: "createdDate",
    sortDirection: "desc",
    searchKey: "",
    sliderValue: 100,
    employeesOnly: jobDetailsInfo?.isEmployeeOnly || false,
    trustedWorkersOnly: (userInfo?.institutionId === jobDetailsInfo?.institutionEntityId || isAdminRole)  && jobDetailsInfo?.isTrustedWorkerOnly || false,
    other: false,
    categoryType: [jobDetailsInfo?.jobPosition],
  });
  const [isLoading, setIsLoading] = useState(false);
  const [errSuccessMesg, setErrSuccessMsg] = useState({
    message: "",
    status: "error",
  });
  const [currentPage, setCurrentPage] = useState(1);
  const [rowPerPage, setRowPerPage] = useState(10);
  const [searchKey, setSearchKey] = useState("");
  const [paginationData, setPaginationData] = useState({
    totalElements: 0,
    totalPages: 0,
  });
  const [employeeWorkersList, setEmployeeWorkersList] = useState([]);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [isSameInstitutionJob] = useState(
    userInfo?.institutionId === jobDetailsInfo?.institutionEntityId
  );


  const handleRecordsPerPageChange = (event) => {
    setCurrentPage(1);
    setRowPerPage(event.target.value);
  };
  const _filterConfig = {
    prefix: "Showing",
    type: "results",
    isSorting: true,
    total: paginationData?.totalElements,
    showRange: false,
    showingUpto: "",
    showAssignInviteEmployeeTrustedWorkerFilter: true,
  };
  const displayErrMsg = (errMsg) => {
    setErrSuccessMsg({
      message: errMsg,
      status: false,
    });
    setIsLoading(false);
    setEmployeeWorkersList([]);
    setPaginationData({
      totalElements: 0,
      totalPages: 0,
    });
  };

  const handleSearchClick = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      setTableFilter({
        ...tableFilter,
        searchKey: searchKey,
      });
      setCurrentPage(1);
    }
  };

  const clearSearch = () => {
    setSearchKey("");
    setCurrentPage(1);
    setTableFilter({
      ...tableFilter,
      searchKey: "",
    });
  };

  const handleSearchKeyChange = (e) => {
    if (e?.target?.value.trim() === "") {
      clearSearch();
    } else {
      setSearchKey(e.target.value);
    }
  };

  const getWorkerType = (tableFilter, isAdminRole) => {
  const types = [];

  if (tableFilter?.employeesOnly) types.push("Employees");
  if (tableFilter?.trustedWorkersOnly) types.push("Trusted Worker");
  if (tableFilter?.other) types.push("Other");

  if (isAdminRole) {
    if (types.length === 3) return "All";
    return types.length > 0 ? types.join(", ") : null;
  }

  if (types.length === 2 || types.length === 3) return "All";
  return types.length > 0 ? types.join(", ") : "All";
};

 const fetchTrustedWorkerEmployeeList = async () => {
    console.log("table filter===", tableFilter)
    try {
      let data = null;

      // const apiEndpoint =
      //   activeTab === "employee"
      //     ? isSameInstitutionJob
      //       ? `institutions/jobs/${jobDetailsInfo?.id}/employeesForPrivateJobs`
      //       : `institutions/jobs/${jobDetailsInfo?.id}/employeesForTrustedCompaniesJobs`
      //     : activeTab === "trusted-worker"
      //     ? `institutions/jobs/${jobDetailsInfo?.id}/trustedWorkersForPrivateJobs`
      //     : "";
      const jobId = jobDetailsInfo?.id;

      let apiEndpoint = "";

      // if (activeTab === "employee") {
      //   if (isAdminRole) {
      //     apiEndpoint = `openstaff/jobs/${jobId}/employeesForPrivateJobs`;
      //   } else if (isSameInstitutionJob) {
      //     apiEndpoint = `institutions/jobs/${jobId}/employeesForPrivateJobs`;
      //   } else {
      //     apiEndpoint = `institutions/jobs/${jobId}/employeesForTrustedCompaniesJobs`;
      //   }
      // } 
      // else if (activeTab === "trusted-worker") {
      //   if (isAdminRole) {
      //     apiEndpoint = `openstaff/jobs/${jobId}/trustedWorkersForPrivateJobs`;
      //   } else {
      //     apiEndpoint = `institutions/jobs/${jobId}/allWorkersForPrivateJob`;
      //   }
      // }
      // else if (activeTab === "all-workers") {
        if (isAdminRole) {
          apiEndpoint = `openstaff/jobs/${jobId}/allWorkers`;
        } else {
          apiEndpoint = `institutions/jobs/${jobId}/allWorkersForPrivateJob`;
        }
      // }

      // const workerType = isAdminRole
      // ? tableFilter?.employeesOnly && tableFilter?.trustedWorkersOnly && tableFilter?.other
      //   ? "All"
      //   : tableFilter?.employeesOnly && tableFilter?.trustedWorkersOnly
      //   ? "Employees, Trusted Worker"
      //   : tableFilter?.employeesOnly && tableFilter?.other
      //   ? "Employees, Other"
      //   : tableFilter?.trustedWorkersOnly && tableFilter?.other
      //   ? "Employees, Other"
      //   : tableFilter?.trustedWorkersOnly
      //   ? "Trusted Worker"
      //   : tableFilter?.other
      //   ? "Other"
      //   : null
      // : tableFilter?.employeesOnly && tableFilter?.trustedWorkersOnly
      // ? "All"
      // : tableFilter?.employeesOnly
      // ? "Employees"
      // : tableFilter?.trustedWorkersOnly
      // ? "Trusted Worker"
      // : "All";

      const workerType = getWorkerType(tableFilter, isAdminRole)

      let api = `${apiEndpoint}?workerType=${workerType}&distance=${tableFilter?.sliderValue}&units=eMiles&sortBy=${
        tableFilter?.sortType
      }&sortDirection=${tableFilter?.sortDirection}&offset=0&page=${
        currentPage - 1
      }&size=${rowPerPage}&searchKey=${tableFilter?.searchKey}`;

      if (isAdminRole) {
        api += `&category=${tableFilter?.categoryType}`;
      }

      setIsLoading(true);
      const result = await apiCall(api, "GET", data, TOKEN);

      console.log("result hire person-----------", result);
      if (result?.data?.content?.length > 0) {
        setEmployeeWorkersList(result.data.content);
        setPaginationData({
          totalElements: result.data.totalElements,
          totalPages: result.data.totalPages,
        });
      } else if (result?.data?.content?.length === 0 && result?.status == 200) {
        setEmployeeWorkersList([]);
        setPaginationData({
          totalElements: 0,
          totalPages: 0,
        });
      } else {
        displayErrMsg(result?.response?.data?.message);
      }
    } catch (error) {
      displayErrMsg("Network Error!");
      console.error("Error fetching user data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  // const applyTrustedCompanyJobToEmployee = async (
  //   applicantId,
  //   applicantInfo
  // ) => {
  //   try {
  //     setSelectedEmployee(applicantId);
  //     const api = `institutions/jobs/${jobDetailsInfo?.id}/applyTrustedCompanyJobs/${applicantId}`;
  //     const appliedEmployeeResponse = await apiCall(api, "POST", null, TOKEN);

  //     if (appliedEmployeeResponse?.status === 200) {
  //       setErrSuccessMsg({
  //         message: `${applicantInfo?.firstName} ${applicantInfo?.lastName} has successfully applied for ${jobDetailsInfo?.jobTitle}`,
  //         status: true,
  //       });
  //       await fetchTrustedWorkerEmployeeList();
  //       await getAppliedApplicantsList();
  //     } else if (appliedEmployeeResponse?.response?.status == 401) {
  //       setErrSuccessMsg({
  //         message: "Your session has been expired!!",
  //         status: false,
  //       });
  //     } else {
  //       setErrSuccessMsg({
  //         message: appliedEmployeeResponse?.response?.data?.errorMessage,
  //         status: false,
  //       });
  //     }
  //   } catch (err) {
  //     console.log("errrrr", err);
  //     setErrSuccessMsg({
  //       message: "Network Error",
  //       status: false,
  //     });
  //   } finally {
  //     setSelectedEmployee(false);
  //   }
  // };

  useEffect(() => {
    if(jobDetailsInfo?.id){
      fetchTrustedWorkerEmployeeList();
    }
  }, [currentPage, tableFilter, rowPerPage]);

  // useEffect(() => {
  //   if (employeeWorkersList?.length > 0) {
  //     setTableFilter({
  //       sortType: "createdDate",
  //       sortDirection: "desc",
  //       searchKey: "",
  //     });
  //     setPaginationData({
  //       totalElements: 0,
  //       totalPages: 0,
  //     });
  //     setCurrentPage(1);
  //     setRowPerPage(10);
  //     setSearchKey("");
  //     setEmployeeWorkersList([]);
  //   }
  //   // else{
  //   //   fetchTrustedWorkerEmployeeList();
  //   // }
  // }, [activeTab]);

  return (
    <>
      <div className="input-group mb-3">
        <input
          type="text"
          className="form-control"
          placeholder="Search By Name"
          id="paymemploent-searchkey"
          value={searchKey}
          onChange={(e) => handleSearchKeyChange(e)}
          onKeyDown={handleSearchClick}
        />
        {searchKey && (
          <button
            type="button"
            className="btn"
            onClick={clearSearch}
            style={{
              position: "absolute",
              right: "40px",
              top: 8,
              zIndex: 2,
              background: "none",
              border: "none",
              cursor: "pointer",
            }}
          >
            <i className="fas fa-times" />
          </button>
        )}
        <button
          type="button"
          className="btn"
          style={{
            position: "absolute",
            right: "10px",
            top: 8,
            zIndex: 2,
            background: "none",
            border: "none",
            cursor: "pointer",
          }}
        >
          <i className="feather-search" onClick={handleSearchClick} />
        </button>
      </div>
      <SectionRecordsFilter
        _config={_filterConfig}
        rowPerPage={rowPerPage}
        handleRecordsPerPageChange={handleRecordsPerPageChange}
        setTableFilter={setTableFilter}
        tableFilter={tableFilter}
        setCurrentPage={setCurrentPage}
        currentPage={currentPage}
        jobDetailsInfo={jobDetailsInfo}
        positionDropdownList={positionDropdownList}
        isSameInstitutionJob={isSameInstitutionJob}
        isAdminRole={isAdminRole}
      />
      <SectionTrustedWorkerEmployeeList
        isLoading={isLoading}
        applicantsListData={employeeWorkersList}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        totalPages={paginationData.totalPages}
        fetchTrustedWorkerEmployeeList={fetchTrustedWorkerEmployeeList}
        // activeTab={activeTab}
        isSameInstitutionJob={isSameInstitutionJob}
        isAdminRole={isAdminRole}
        // applyTrustedCompanyJobToEmployee={applyTrustedCompanyJobToEmployee}
        selectedEmployee={selectedEmployee}
        jobDetailsInfo={jobDetailsInfo}
      />
      {errSuccessMesg?.message !== "" ? <Toast message={errSuccessMesg} /> : ""}
    </>
  );
};

export default TrustedWorkersEmployeeList;
